import { render, staticRenderFns } from "./map-wizard.vue?vue&type=template&id=0fa60091&"
import script from "./map-wizard.vue?vue&type=script&lang=js&"
export * from "./map-wizard.vue?vue&type=script&lang=js&"
import style0 from "./_map-wizard.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports